const supplier_user_items = [
    {
        icon: 'mdi-truck',
        title: 'container-box.customer-list',
        to: '/tables/supplier-container-box-list',
    },
];
export {
    supplier_user_items
};
